// import axios from "axios";
// import qs from "qs";

import api from '@/api'

export default {
  namespaced: true,
  state: {
    formData: {
      hasNote: false,
      note: '',
      hasLogistNote: false,
      logistNote: '',
      useBonuses: false,
      spentBonuses: 0
      // promoCode: '',
      // promoCodeError: ''
    },
    pending: false,
    errorFromServer: '',
    errorModalData: {},
    wayforpayForm: '',
    needValidation: false,
    resetValidation: false
  },
  getters: {
    totalPrice: (state, getters, rootState, rootGetters) => () => {
      const delivery = rootGetters['deliveryNew/deliveryPrice']
      const { translations } = rootGetters
      const deliverySumm = translations('delivery.free.price') === delivery() ? 0 : delivery()
      return rootState.cart.cart.originCost + deliverySumm - (state.formData.useBonuses ? state.formData.spentBonuses : 0)
    },
    isCheckoutValid: (state, getters, rootState, rootGetters) => () => {
      const isContactsFormValid = rootGetters['contactsNew/isContactsFormValid']
      const isDeliveryFormValid = rootGetters['deliveryNew/isDeliveryFormValid']
      const isPaymentFormValid = rootGetters['paymentNew/isPaymentFormValid']
      const isRecipientFormValid = rootGetters['recipientNew/isRecipientFormValid']
      const isAnotherRecipient = rootState.recipientNew.isAnotherRecipient
      return (isAnotherRecipient ? isRecipientFormValid : isContactsFormValid) && isDeliveryFormValid && isPaymentFormValid
    }
  },
  mutations: {
    SET_DATA (state, data) {
      state.formData = { ...state.formData, ...data }
      localStorage.setItem('checkoutNewData', JSON.stringify(state.formData))
    },
    SET_NEED_VALIDATION (state) {
      state.needValidation = true
      setTimeout(() => {
        state.needValidation = false
      }, 200)
    },
    SET_RESET_VALIDATION (state) {
      state.resetValidation = true
      setTimeout(() => {
        state.resetValidation = false
      }, 200)
    },
    SET_ERROR_FROM_SERVER (state, data) {
      let error = data
      if (state.errorFromServer === data) {
        if (error[error.length] === ' ') {
          error.substr(0, error.length - 1)
        } else {
          error = error + ' '
        }
      }
      state.errorFromServer = error
    },
    SET_ERROR_MODAL_DATA (state, data) {
      state.errorModalData = data
    },
    SET_HAS_NOTE (state, data) {
      state.formData.hasNote = data
      localStorage.setItem('checkoutNewData', JSON.stringify(state.formData))
    },
    SET_HAS_LOGIST_NOTE (state, data) {
      state.formData.hasLogistNote = data
    },
    SET_WAY_FOR_PAY_FORM (state, data) {
      state.wayforpayForm = data
    },
    SET_PENDING (state, data) {
      state.pending = data
    },
    // SET_PROMO_CODE (state, data) {
    //   state.formData.promoCode = data
    // },
    SET_USE_BONUSES (state, data) {
      state.formData.useBonuses = data
      localStorage.setItem('checkoutNewData', JSON.stringify(state.formData))
    },
    SET_NOTE (state, data) {
      state.formData.note = data
      localStorage.setItem('checkoutNewData', JSON.stringify(state.formData))
    },
    SET_LOGIST_NOTE (state, data) {
      state.formData.logistNote = data
    },
    SET_SPENT_BONUS (state, data) {
      state.formData.spentBonuses = data
      localStorage.setItem('checkoutNewData', JSON.stringify(state.formData))
    }
    // SET_CHECKOUT_DATA (state, data) {
    //   state.formData = data
    // }
  },
  actions: {
    SET_NEED_VALIDATION ({ commit }) {
      commit('SET_NEED_VALIDATION')
    },
    SET_RESET_VALIDATION ({ commit }) {
      commit('SET_RESET_VALIDATION')
    },
    SET_HAS_NOTE ({ commit }, data) {
      commit('SET_HAS_NOTE', data)
    },
    SET_HAS_LOGIST_NOTE ({ commit }, data) {
      commit('SET_HAS_LOGIST_NOTE', data)
    },
    SET_USE_BONUSES ({ commit }, data) {
      commit('SET_USE_BONUSES', data)
    },
    SET_NOTE ({ commit }, data) {
      commit('SET_NOTE', data)
    },
    SET_LOGIST_NOTE ({ commit }, data) {
      commit('SET_LOGIST_NOTE', data)
    },
    SET_SPENT_BONUS ({ commit }, data) {
      commit('SET_SPENT_BONUS', data)
    },
    SUBMIT_LIQPAY_FORM_ACTION (ctx, { data, url, signature }) {
      try {
        const liqpayForm = document.createElement('form')
        document.body.appendChild(liqpayForm)
        liqpayForm.method = 'POST'
        liqpayForm.action = url
        liqpayForm.acceptCharset = 'utf-8'
        liqpayForm.innerHTML = `
        <input name='data' type='hidden' value='${data}'>
        <input name='signature' type='hidden' value='${signature}'>
        `
        liqpayForm.submit()
      } catch (error) {}
    },
    CREATE_ORDER ({ commit, state, getters, rootGetters, rootState, dispatch }) {
      const { name, last_name, father_name, phone, email } = rootState.contactsNew.formData
      const { deliveryCity, deliveryMethod, selectedSpot, courierData } = rootState.deliveryNew.formData
      const { note, useBonuses, spentBonuses, hasNote } = state.formData
      const { isManagerPage } = rootState.checkout
      const { paymentMethod, payPartMonth, legalPersonInfo } = rootState.paymentNew.formData
      const { isAnotherRecipient, formData: recipientData } = rootState.recipientNew
      const orderInfo = {
        User: {
          name, last_name, father_name
        },
        CustomerForm: {
          phone: phone.replace(/^\+/, ''),
          email
        },
        DeliveryForm: {
          city: deliveryCity?.id || '',
          method: deliveryMethod?.method_id || ''
        },
        OrderForm: {
          paymentMethod: parseInt(paymentMethod.id),
          callBack: 1
        }
      }
      if (hasNote && note) {
        orderInfo.OrderForm.note = note
      }
      if (isManagerPage) {
        orderInfo.OrderForm.callback = 1
        orderInfo.client_phone = phone.replace(/^\+/, '')
        if (state.formData.hasLogistNote) {
          orderInfo.OrderForm.comment_for_logist = state.formData.logistNote
        }
      }
      if (isAnotherRecipient) {
        orderInfo.OrderForm = {
          ...orderInfo.OrderForm,
          another_recipient: true,
          recipientName: recipientData.recipient_name,
          recipientFatherName: recipientData.recipient_father_name,
          recipientLastName: recipientData.recipient_last_name,
          recipient_phone: recipientData.recipient_phone.replace(/^\+/, '')
        }
      }
      if (useBonuses && spentBonuses) {
        orderInfo.bonuses = spentBonuses
      }
      if (payPartMonth && (paymentMethod.id === '5' || paymentMethod.id === '10')) {
        orderInfo.OrderForm.countPartsPayPart = payPartMonth
      }
      if (deliveryMethod.method_id === 1 || deliveryMethod.method_id === 3 || deliveryMethod.method_id === 5 || deliveryMethod.method_id === 7) {
        orderInfo.WarehouseForm = { warehouse: selectedSpot.uid }
      }
      if (deliveryMethod.method_id === 4) {
        orderInfo.AddressForm = { street: courierData.street.name, house: courierData.house, flatNumber: courierData.flat || '' }
      }
      if (deliveryMethod.method_id === 2 || deliveryMethod.method_id === 6) {
        orderInfo.AddressForm = { street: courierData.street.name, house: courierData.house, flatNumber: courierData.flat || '', deliveryDay: courierData.time.date, deliveryTime: courierData.time.title }
      }
      if (paymentMethod.id === '3') {
        const { formId, formRef, full_name: organization, inn, pdv_status, egr, firmEgr, firmTitle, documentNdsStatus, shortName } = legalPersonInfo
        orderInfo.PaymentForm = {
          organization_type: formRef,
          egrpou: egr,
          organization: organization,
          inn: inn,
          pdv_status: pdv_status ? 1 : 0,
          document_nds_status: documentNdsStatus
        }
        if (firmEgr) {
          orderInfo.PaymentForm.firmEgr = firmEgr
        }
        if (firmTitle) {
          orderInfo.PaymentForm.firmTitle = firmTitle
        }
        if (shortName) {
          orderInfo.PaymentForm.shortName = shortName
        }
        if (formId === '82a553c6-4f94-11e8-a3de-005056b2fc3d') {
          orderInfo.PaymentForm.organization = firmTitle
          orderInfo.PaymentForm.egrpou = firmEgr
        } else if (formId === 'd558bfcc-7456-11df-ad52-000c29118aa7') {
          orderInfo.PaymentForm.egrpou = inn
        } else if (documentNdsStatus === '1' && !egr && inn) {
          orderInfo.PaymentForm.egrpou = inn
        }
      }
      if (isManagerPage) {
        if (legalPersonInfo.phoneNumberForPayment && legalPersonInfo.phoneNumberForPayment.isValid) {
          orderInfo.phone_number_for_payment = '380' + legalPersonInfo.phoneNumberForPayment.value
        }
      }
      commit('SET_PENDING', true)
      return new Promise((resolve, reject) => {
        api.checkout.createOrder(orderInfo).then(response => {
          const { order, redirect_url } = response
          if (order && !order.status && order.error_message) {
            if (order.error_code === 1) {
              dispatch('GET_FULL_CART', {}, { root: true })
            } else if (order.error_code === 3) {
              dispatch('deliveryNew/FETCH_DELIVERY_TYPES', {}, { root: true })
              dispatch('deliveryNew/SET_DELIVERY_IS_OPEN', true, { root: true })
              commit('SET_ERROR_MODAL_DATA', {
                title: order.error_message || '',
                subtitle: '',
                products: []
              })
            } else if (order.error_code === 4) {
              dispatch('paymentNew/FETCH_PAYMENT_METHODS', {}, { root: true })
            } else {
              dispatch('GET_FULL_CART', {}, { root: true })
              commit('SET_ERROR_FROM_SERVER', order.error_message)
              if (deliveryMethod.method_id === 2) {
                // если курьер дм просрочился по времени доставки обновляем данные, сохраняя всё кроме времени
                let oldCourierData = courierData
                if (oldCourierData['time']) {
                  delete oldCourierData['time']
                }
                dispatch('deliveryNew/SET_COURIER_DATA', null, { root: true })
                dispatch('deliveryNew/SET_COURIER_DATA', oldCourierData, { root: true })
                dispatch('deliveryNew/FETCH_DELIVERY_INFO', {}, { root: true })
                dispatch('deliveryNew/SET_DELIVERY_IS_OPEN', true, { root: true })
              }
            }
            commit('SET_PENDING', false)
          } if (order && !order.status && order.order_composition) {
            commit('SET_ERROR_MODAL_DATA', {
              title: order.order_composition.error_message_heading || '',
              subtitle: order.order_composition.error_message_subtitle || '',
              products: order.order_composition.missing_products || []
            })
            commit('SET_PENDING', false)
          } if (order && order.liqpay_data && !isManagerPage) {
            dispatch('SUBMIT_LIQPAY_FORM_ACTION', order.liqpay_data)
          } else if (order && order.wayforpay_data && !isManagerPage) {
            commit('SET_WAY_FOR_PAY_FORM', order.wayforpay_data.form)
          } else if (order && order.paypart_data && order.paypart_data.url && !isManagerPage) {
            window.location.replace(order.paypart_data.url)
          } else if (order && order.status) {
            window.location.replace(redirect_url)
          }
          resolve(order)
        }).catch(error => reject(error))
      })
    },
    SET_CHECKOUT_DATA ({ commit }, data) {
      commit('SET_DATA', data)
    }
    // SET_PROMO_CODE ({ commit }, data) {
    //   commit('SET_PROMO_CODE', data)
    // }
    // SET_FORM_DATA (ctx, data) {
    //   ctx.commit('SET_CHECKOUT_DATA', data)
    // }
  }
}
